// default to an empty object, because the react components need to render
// even if global data is undefined, like for example in the storybook
export default window.ksk001_global_data || {}
